// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ChevronRightDoubleIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon
      data-iconname="ChevronRightDoubleIcon"
      ref={forwardedRef}
      {...props}
    >
      <path d="M10.635 16.365 17 10l-6.364-6.364-1.057 1.057 5.3 5.307-5.303 5.303z" />
      <path d="M5.637 16.363 12 10 5.637 3.635 4.579 4.693l5.3 5.306-5.303 5.304z" />
    </SvgIcon>
  );
});

/**
 * Use to expand or collapse elements. Use CloseSidebarIcon or OpenSidebarIcon for sidebar
 * @public
 */
export const ChevronRightDoubleIcon = /* @__PURE__ */ Object.assign(
  ChevronRightDoubleIconComponent,
  { displayName: 'ChevronRightDoubleIcon' },
);
